import { ListCollectionList } from "@corpuscomplete/core-ui/common/list-collection/list";
import { Scope } from "@corpuscomplete/core/common/scope";
import { FoodCollectionList } from "@corpuscomplete/core-ui/nutrition/food-collection/list";
import { useAuth } from "@corpuscomplete/web/auth/hooks";
import { CollectionsPage } from "@corpuscomplete/web/modules/common/collections/pages/collections";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/collections/")({
  component: () => {
    const { userId } = useAuth();
    return <CollectionsPage scope={Scope.personal(userId)} />;
  },
  loader: async ({ context: { zero } }) => {
    if (zero) {
      FoodCollectionList.preload(zero);
      ListCollectionList.preload(zero);
    }
  },
});
